import { createAction } from "redux-actions";

export const saveLanguage = createAction("SAVE_LANGUAGE");
export const saveLanguagePublic = createAction("SAVE_LANGUAGE_PUBLIC");
